import React, {ChangeEvent } from 'react';

interface RadioButtonProps {
    value: string;
    name: string;
    selected: boolean;
    onValueChange?: (value: string) => void;
    index?: number;
    disabled?: boolean;
}

export const RadioButton = (props: RadioButtonProps) => {

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (props.onValueChange) {
            props.onValueChange(props.value);
        }
    };

    return (
        <div key={props.index ?? 0} className="radio">
            <label>
                <input type="radio" value={props.value} onChange={handleInputChange} checked={props.selected} disabled={props.disabled} /> {props.name}
            </label>
        </div>
    );
}
